<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/member' }">服务人员</el-breadcrumb-item>
            <el-breadcrumb-item>人员详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="order-info">
            <div class="area-title">人员信息</div>
            <div class="cell-group border__top">
                <div class="cell">
                    <div class="cell-title">姓名</div>
                    <div class="cell-value">{{member.name}}</div>
                </div>
                <div class="cell">
                    <div class="cell-title">手机号</div>
                    <div class="cell-value">{{member.phone}}</div>
                </div>
            </div>
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">认证证件</div>
                    <div class="cell-value">身份证</div>
                </div>
                <div class="cell">
                    <div class="cell-title">身份证号</div>
                    <div class="cell-value">{{member.idcard}}</div>
                </div>
            </div>
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">收款银行</div>
                    <div class="cell-value">{{member.bank_name}}</div>
                </div>
                <div class="cell">
                    <div class="cell-title">银行卡号</div>
                    <div class="cell-value">{{member.bank_card}}</div>
                </div>
            </div>
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">自动确认接单</div>
                    <div class="cell-value">{{member.auto_order ? '已开启':'未开启'}}</div>
                </div>
                <div class="cell">
                    <div class="cell-title">自动申请结算</div>
                    <div class="cell-value">{{member.auto_apply ? '已开启':'未开启'}}</div>
                </div>
            </div>
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">加入时间</div>
                    <div class="cell-value">{{member.join_time}}</div>
                </div>
                <div class="cell">
                    <div class="cell-title">收入次数</div>
                    <div class="cell-value">{{member.settlement_count}}</div>
                </div>
            </div>
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">累计收入(元)</div>
                    <div class="cell-value">{{member.settlement_total}}</div>
                </div>
                <div class="cell">
                    <div class="cell-title">代缴个税(元)</div>
                    <div class="cell-value">{{member.tax}}</div>
                </div>
            </div>
        </div>
        <div class="content-box">
            <div class="area-title in-content">结算详情</div>
            <div class="table">
                <el-table
                    :data="records"
                    :border="true"
                    :stripe="true"
                >
                    <el-table-column
                        prop="no"
                        align="center"
                        label="序号">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        align="center"
                        label="所属项目">
                    </el-table-column>
                    <el-table-column
                        prop="service_no"
                        align="center"
                        label="服务编号">
                    </el-table-column>
                    <el-table-column
                        prop="money"
                        align="center"
                        label="结算金额">
                    </el-table-column>
                    <el-table-column
                        prop="confirm_settlement_time"
                        align="center"
                        label="结算时间">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="结算状态">
                        <template slot-scope="scope">
                            <div>
                                {{statusList[scope.row.status]}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="goPage(`/index/project/serviceinfo?id=${scope.row.id}&sub_id=${scope.row.sub_id}`)">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Detail',
    inject: ['goPage'],
    data () {
        return {
            statusList: ['', '', '', '', '', '', '', '', '', '', '打款中', '打款失败，请联系客服', '重新发起打款', '已完成'],
            member: {

            },
            records: []
        }
    },
    mounted () {
        this.getMember(this.$route.query.id)
    },
    methods: {
        getMember (id) {
            this.$http.get('/api/user/member/info', {
                params: {
                    member_id: id
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.member = res.data.base
                        this.records = res.data.payments
                    } else {
                        this.$message.warning(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";
    .order-info {
        margin-top: 20px;
        padding: 20px 40px;
        background-color: #fff;
    }
    .pay-form {
        width: 410px;
        margin: 53px auto;
    }
    .cell-group {
        display: flex;
        border-right: 1px solid #ebeef5;
        .cell {
            flex: 1;
            border-bottom: 1px solid #ebeef5;
            border-left: 1px solid #ebeef5;
            display: flex;
            align-items: center;
            color: #333333;
            .cell-title {
                background-color: #f5f5fa;
                flex: 1;
                padding: 17px 20px;
            }
            .cell-value {
                flex: 1;
                padding: 17px 20px;
                max-width: 50%;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        &:nth-child(1) {
            border-top: 1px solid #ebeef5;
        }
    }
    .area-title {
        background-color: #fff;
        margin-left: 0;
        font-size: 16px;
        color: $--color-primary;
        font-weight: 500;
        padding-bottom: 18px;
        position: relative;
        &::before {
            content: "";
            position: absolute;
            width: 4px;
            height: 20px;
            background-color: $--color-primary;
            left: -20px;
            top: -2px;
        }
        &.in-content {
            padding-left: 40px;
            &::before {
                left: 20px;
            }
        }
    }
</style>
